import { PaginationState } from 'app/shared/pagination/pagination.model';
import axios from 'axios';
import {
  PublicAuthorityOverviewFilterModel,
  PublicAuthorityOverviewRow,
} from 'app/edozvola/public-authority-overview/model/public-authority-overview.model';

export const fetchPublicAuthorityOverview = async (pagination: PaginationState, filterDto: PublicAuthorityOverviewFilterModel): Promise<PublicAuthorityOverviewRow[]> => {
  return await new Promise((resolve, reject) => {
    axios.post(`/api/public-authority-overview?page=${pagination.page}&size=${pagination.size}&column=${pagination.column}&direction=${pagination.direction}`, filterDto)
      .then(res => {
        resolve(res.data);
      })
      .catch(error => {
        reject(error);
      })
  });
};
